module.exports = __webpack_public_path__ + "static/media/chopin_airport_logo_EN.6959cca1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chopin_airport_logo_EN.png
// module id = 1064
// module chunks = 0